<template>
    <div class="modal fade" id="deleteAnswerModal" ref="deleteAnswerModal" tabindex="-1" role="dialog" aria-labelledby="deleteAnswerModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header" style="padding-bottom: 0;">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img src="./../../assets/ics.svg" alt="ics" />
                    </button>
                </div>
                <div class="modal-body" style="padding-top: 0;">
                    <div class="row">
                        <div class="col-12 text-center">
                            <h5 class="modal-title-delete-account" id="deleteAnswerModalLabel">{{ $t('delete_answer.title') }}</h5>
                        </div>
                        <div class="col-12 text-left">
                            <span class="note-text">{{ $t('delete_answer.warning_text') }}</span>
                        </div>
                        <div class="col-12 text-left mt-4 mb-3">
                            <label class="container-permanent-confirm note-text"><span class="permanent-confirm-label">{{ $t('delete_answer.permanently_delete') }}</span>
                                <input type="checkbox" v-model="deleteAnswer">
                                <span class="checkmark-permanent"></span>
                            </label>
                        </div>
                    </div>
                </div>
                <div v-if="deleteAnswer" class="modal-footer modal-footer-canvassing-redish">
                    <div class="row w-100">
                        <div class="col-6">
                            <span @click.prevent="doDeleteAnswer" class="modal-footer-canvassing-red-button float-right cursor-pointer">{{ $t('delete_answer.delete') }}</span>
                        </div>
                        <div class="col-6">
                            <span data-dismiss="modal" class="modal-footer-canvassing-black-button float-left cursor-pointer">{{ $t('delete_answer.cancel') }}</span>
                        </div>
                    </div>
                </div>
                <div v-else class="modal-footer modal-footer-canvassing-grey">
                    <div class="row w-100">
                        <div class="col-6">
                            <span class="modal-footer-canvassing-black-button float-right">{{ $t('delete_answer.delete') }}</span>
                        </div>
                        <div class="col-6">
                            <span data-dismiss="modal" class="modal-footer-canvassing-black-button float-left">{{ $t('delete_answer.cancel') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: "DeleteAnswerModal",
        props: ["answer", "question", "index"],
        mixins: [HelperMixin],
        data() {
            return {
                deleteAnswer: false
            }
        },
        created() {
                      
        },
        mounted() {
            $(this.$refs['deleteAnswerModal']).on('hide.bs.modal', this.resetDelete);
        },
        methods: {
            resetDelete() {
                this.deleteAnswer = false;
            },

            doDeleteAnswer() {
                this.$parent.deleteAnswer(this.answer, this.question, this.index);
            },
        },
    }
</script>